export const LOG_USER_IN = 'LOG_USER_IN'
export const LOG_USER_IN_BY_TOKEN = 'LOG_USER_IN_BY_TOKEN'
export const LOAD_APP_MENU = 'LOAD_APP_MENU'
export const LOG_USER_OUT = 'LOG_USER_OUT'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SELECT_UI_LANGUAGE = 'SELECT_UI_LANGUAGE'
export const LOAD_CURRENT_USER_ABSENCES = 'LOAD_CURRENT_USER_ABSENCES'
export const LOAD_CURRENT_USER_BALANCE = 'LOAD_CURRENT_USER_BALANCE'
export const SET_UPDATE_MENU = 'SET_UPDATE_MENU'
export const SET_SHOW_MENU_ADDRESS = 'SET_SHOW_MENU_ADDRESS'
export const SET_SHOW_MENU_PROJECT = 'SET_SHOW_MENU_PROJECT'
export const SET_SHOW_MENU_DISPOSITION = 'SET_SHOW_MENU_DISPOSITION'
export const SET_IS_ALL_DAY_LONG = 'SET_IS_ALL_DAY_LONG'

// QCQ
export const LOAD_EDUCATION = 'LOAD_EDUCATION'
export const LOAD_JOBS = 'LOAD_JOBS'
export const LOAD_SPECIALIZATION = 'LOAD_SPECIALIZATION'
export const LOAD_SPECIALIZATION_ROW = 'LOAD_SPECIALIZATION_ROW'
export const LOAD_EDUCATION_ROW = 'LOAD_EDUCATION_ROW'
export const LOAD_JOBS_ROW = 'LOAD_JOBS_ROW'
export const LOAD_DETAIL = 'LOAD_DETAIL'
export const LOAD_COMPETENCE = 'LOAD_COMPETENCE'
export const LOAD_DETAIL_ROW = 'LOAD_DETAIL_ROW'
export const LOAD_COMPETENCE_ROW = 'LOAD_COMPETENCE_ROW'
export const INSERT_EDUCATION = 'INSERT_EDUCATION'
export const UPDATE_EDUCATION = 'UPDATE_EDUCATION'
export const DELETE_EDUCATION = 'DELETE_EDUCATION'
export const INSERT_JOB = 'INSERT_JOB'
export const UPDATE_JOB = 'UPDATE_JOB'
export const DELETE_JOB = 'DELETE_JOB'
export const INSERT_SPECIALIZATION = 'INSERT_SPECIALIZATION'
export const UPDATE_SPECIALIZATION = 'UPDATE_SPECIALIZATION'
export const DELETE_SPECIALIZATION = 'DELETE_SPECIALIZATION'
export const INSERT_DETAIL = 'INSERT_DETAIL'
export const UPDATE_DETAIL = 'UPDATE_DETAIL'
export const DELETE_DETAIL = 'DELETE_DETAIL'
export const INSERT_COMPETENCE = 'INSERT_COMPETENCE'
export const UPDATE_COMPETENCE = 'UPDATE_COMPETENCE'
export const DELETE_COMPETENCE = 'DELETE_COMPETENCE'
export const LOAD_MASTER_DATA_QCQ_QUALITY = 'LOAD_MASTER_DATA_QCQ_QUALITY'
export const EDIT_MASTER_DATA_QCQ_QUALITY = 'EDIT_MASTER_DATA_QCQ_QUALITY'
// MASTER DATA
export const LOAD_MASTER_DATA_FREE_SHIFT_LIST = 'LOAD_MASTER_DATA_FREE_SHIFT_LIST'
export const FETCH_MASTER_DATA_WORK_LIST = 'FETCH_MASTER_DATA_WORK_LIST'
export const CREATE_MASTER_DATA_WORK_LIST = 'CREATE_MASTER_DATA_WORK_LIST'
export const EDIT_MASTER_DATA_WORK_LIST = 'EDIT_MASTER_DATA_WORK_LIST'
export const DELETE_MASTER_DATA_WORK_LIST = 'DELETE_MASTER_DATA_WORK_LIST'
export const LOAD_MASTER_DATA_WORK_ROW = 'LOAD_MASTER_DATA_WORK_ROW'
export const INSERT_MASTER_DATA_FREE_SHIFT = 'INSERT_MASTER_DATA_FREE_SHIFT'
export const LOAD_MASTER_DATA_QCQ_SHIFT_LIST = 'LOAD_MASTER_DATA_QCQ_SHIFT_LIST'
export const INSERT_MASTER_DATA_QCQ_SHIFT = 'INSERT_MASTER_DATA_QCQ_SHIFT'
export const LOAD_COMPANY_STRUCTURE = 'LOAD_COMPANY_STRUCTURE'
export const FETCH_MAX_STARS = 'FETCH_MAX_STARS'

// CompanyStructure
export const COMPANY_FETCH_COMPANY_STRUCTURE = 'COMPANY_FETCH_COMPANY_STRUCTURE'
export const COMPANY_FETCH_DEPARTMENT_EMPLOYEE_LIST = 'COMPANY_FETCH_DEPARTMENT_EMPLOYEE_LIST'
export const COMPANY_FETCH_COMPANY_EMPLOYEE_LIST = 'COMPANY_FETCH_COMPANY_EMPLOYEE_LIST'
export const COMPANY_FETCH_PROFIT_CENTER_CALENDAR_EVENTS = 'COMPANY_FETCH_PROFIT_CENTER_CALENDAR_EVENTS'
export const FETCH_EVENT_LIST = 'FETCH_EVENT_LIST'
export const COMPANY_UPDATE_DELETE_CALENDAR_EVENT = 'COMPANY_UPDATE_DELETE_CALENDAR_EVENT'
export const FETCH_CALENDAR_EVENT_LANGUAGES = 'FETCH_CALENDAR_EVENT_LANGUAGES'
export const COMPANY_INSERT_CALENDAR_EVENT = 'COMPANY_INSERT_CALENDAR_EVENT'
export const COMPANY_FETCH_DEPARTMENT_PLANNING_GROUPS = 'COMPANY_FETCH_DEPARTMENT_PLANNING_GROUPS'
export const FETCH_PLANNING_GROUP_LIST = 'FETCH_PLANNING_GROUP_LIST'
export const COMPANY_UPDATE_DELETE_PLANNING_GROUP = 'COMPANY_UPDATE_DELETE_PLANNING_GROUP'
export const FETCH_PLANNING_GROUP_LANGUAGES = 'FETCH_PLANNING_GROUP_LANGUAGES'
export const COMPANY_INSERT_PLANNING_GROUP = 'COMPANY_INSERT_PLANNING_GROUP'
export const FETCH_PROFIT_CENTER_ADDITIONAL = 'FETCH_PROFIT_CENTER_ADDITIONAL'
export const SAVE_PROFIT_CENTER_ADDITIONAL = 'SAVE_PROFIT_CENTER_ADDITIONAL'

// Planning
export const LOAD_SHIFTS = 'LOAD_SHIFTS'
export const LOAD_PLAN = 'LOAD_PLAN'
export const GET_SHIFTS_DEFINITION = 'GET_SHIFTS_DEFINITION'
export const GET_ADDITIONAL_FIELDS = 'GET_ADDITIONAL_FIELDS'
export const CREATE_SHIFT_NEW = 'CREATE_SHIFT_NEW'
export const DELETE_PROJECT_SERIEN = 'DELETE_PROJECT_SERIEN'
export const UPDATE_PROJECT_SERIEN = 'UPDATE_PROJECT_SERIEN'
export const READ_PROJECTS = 'READ_PROJECTS'
export const INSERT_CALENDAR_ART = 'INSERT_CALENDAR_ART'
export const READ_MESSAGES_FROM_PLANNING = 'READ_MESSAGES_FROM_PLANNING'
export const LOAD_SHIFT_TEMPLATE_LIST = 'LOAD_SHIFT_TEMPLATE_LIST'
export const LOAD_SHIFT_TEMPLATE_LIST_FILTER = 'LOAD_SHIFT_TEMPLATE_LIST_FILTER'
export const FETCH_EMPLOYEE_PLACEHOLDER_LIST = 'FETCH_EMPLOYEE_PLACEHOLDER_LIST'
export const AUTOMATICALLY_PLAN_EMPLOYEES = 'AUTOMATICALLY_PLAN_EMPLOYEES'
export const FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING = 'FETCH_AVAILABLE_EMPLOYEES_FOR_PLANNING'
export const FETCH_TASK_LIST = 'FETCH_TASK_LIST'
export const DELETE_CALENDAR_ART = 'DELETE_CALENDAR_ART'
export const FETCH_EDIT_SHIFT = 'FETCH_EDIT_SHIFT'
export const UPDATE_SHIFT_PLAN = 'UPDATE_SHIFT_PLAN'
export const UPDATE_AUTO_SHIFT_PLAN = 'UPDATE_AUTO_SHIFT_PLAN'
export const UPDATE_SHIFT_PROJECT = 'UPDATE_SHIFT_PROJECT'
export const EVENT_DRAG_SAVE = 'EVENT_DRAG_SAVE'
export const FIX_PROJECT_SERIE = 'FIX_PROJECT_SERIE'
export const COMPLETE_SHIFT_LIST = 'COMPLETE_SHIFT_LIST'
export const ACTIVATE_SHIFT_LIST = 'ACTIVATE_SHIFT_LIST'
export const DEACTIVATED_SHIFT_LIST = 'DEACTIVATED_SHIFT_LIST'
export const DELETE_CHECKED_LIST = 'DELETE_CHECKED_LIST'
export const FETCH_CAPACITY_LIST = 'FETCH_CAPACITY_LIST'
export const SCHEDULER_AUTO_PLANNING = 'SCHEDULER_AUTO_PLANNING'
export const SEARCH_ADDRESS_LIST = 'SEARCH_ADDRESS_LIST'
export const SEARCH_ADDRESS_BY_ID = 'SEARCH_ADDRESS_BY_ID'
export const FETCH_STATISTIC_DATA = 'FETCH_STATISTIC_DATA'
export const DELETE_SHIFT = 'DELETE_SHIFT'
export const SAVE_SHIFT_ADDRESS_EMPLOYEE_NOTE = 'SAVE_SHIFT_ADDRESS_EMPLOYEE_NOTE'
export const FETCH_EMPLOYEE_NOTE = 'FETCH_EMPLOYEE_NOTE'
export const FETCH_ADDRESS_NOTE = 'FETCH_ADDRESS_NOTE'
export const FETCH_SHIFT_NOTE = 'FETCH_SHIFT_NOTE'
export const FETCH_SHIFT_TOOLTIP = 'FETCH_SHIFT_TOOLTIP'
export const FETCH_ABSENCE_TOOLTIP = 'FETCH_ABSENCE_TOOLTIP'
export const FETCH_CALENDAR_ART_TOOLTIP = 'FETCH_CALENDAR_ART_TOOLTIP'
export const FETCH_SCHEDULER_SETTINGS = 'FETCH_SCHEDULER_SETTINGS'
export const SAVE_SCHEDULER_SETTINGS = 'SAVE_SCHEDULER_SETTINGS'
export const FETCH_ADDITIONAL_SERVICES = 'FETCH_ADDITIONAL_SERVICES'
export const FETCH_ADDITIONAL_SERVICES_EXPENSES = 'FETCH_ADDITIONAL_SERVICES_EXPENSES'
export const FETCH_ADDITIONAL_SERVICES_PROVISION = 'FETCH_ADDITIONAL_SERVICES_PROVISION'
export const FETCH_ADDITIONAL_SERVICES_DISCOUNT = 'FETCH_ADDITIONAL_SERVICES_DISCOUNT'
export const FETCH_ADDITIONAL_SERVICES_PRODUCT_LIST = 'FETCH_ADDITIONAL_SERVICES_PRODUCT_LIST'
export const FETCH_ADDITIONAL_SERVICES_CURRENCY_LIST = 'FETCH_ADDITIONAL_SERVICES_CURRENCY_LIST'
export const FETCH_ADDITIONAL_SERVICES_PROVISION_LIST = 'FETCH_ADDITIONAL_SERVICES_PROVISION_LIST'
export const FETCH_ADDITIONAL_SERVICES_DISCOUNT_LIST = 'FETCH_ADDITIONAL_SERVICES_DISCOUNT_LIST'
export const INSERT_ADDITIONAL_SERVICE = 'INSERT_ADDITIONAL_SERVICE'
export const EDIT_ADDITIONAL_SERVICE = 'EDIT_ADDITIONAL_SERVICE'
export const DELETE_ADDITIONAL_SERVICE = 'DELETE_ADDITIONAL_SERVICE'
export const INSERT_ADDITIONAL_SERVICE_EXPENSES = 'INSERT_ADDITIONAL_SERVICE_EXPENSES'
export const EDIT_ADDITIONAL_SERVICE_EXPENSES = 'EDIT_ADDITIONAL_SERVICE_EXPENSES'
export const DELETE_ADDITIONAL_SERVICE_EXPENSES = 'DELETE_ADDITIONAL_SERVICE_EXPENSES'
export const SEARCH_ADDRESSLINIE_LIST = 'SEARCH_ADDRESSLINIE_LIST'
export const FETCH_INVOICING_DATA = 'FETCH_INVOICING_DATA'
export const FETCH_INVOICING_STATUS = 'FETCH_INVOICING_STATUS'
export const CREATE_INVOICES = 'CREATE_INVOICES'
export const FETCH_EMPLOYEE_PLAN_DETAIL = 'FETCH_EMPLOYEE_PLAN_DETAIL'
export const FETCH_PROJECT_ADDITIONAL = 'FETCH_PROJECT_ADDITIONAL'
export const FETCH_PRESELECTED_EMPLOYEE = 'FETCH_PRESELECTED_EMPLOYEE'

//<editor-fold desc="Planning Assistant Actions">
export const PLANNING_ASSISTANT_RESET_STATE = 'RESET_PLANNING_ASSISTANT_STATE'
export const PLANNING_ASSISTANT_INIT_FROM_PAYLOAD = 'PLANNING_ASSISTANT_INIT_FROM_PAYLOAD'
export const PLANNING_ASSISTANT_SET_START_END_DATA = 'PLANNING_ASSISTANT_SET_START_END_DATA'
export const PLANNING_ASSISTANT_SET_START_DATE = 'PLANNING_ASSISTANT_SET_START_DATE'
export const PLANNING_ASSISTANT_SET_END_DATE = 'PLANNING_ASSISTANT_SET_END_DATE'
export const PLANNING_ASSISTANT_SET_PERIODICITY = 'PLANNING_ASSISTANT_SET_PERIODICITY'
export const PLANNING_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING = 'PLANNING_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING'
export const PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST = 'PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST'
export const PLANNING_ASSISTANT_SET_TASK_LIST = 'PLANNING_ASSISTANT_SET_TASK_LIST'
export const PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY = 'PLANNING_ASSISTANT_SET_SHIFT_AVAILABILITY'
export const PLANNING_ASSISTANT_SET_EMPLOYEE_FOR_EXCHANGE = 'PLANNING_ASSISTANT_SET_EMPLOYEE_FOR_EXCHANGE'
export const PLANNING_ASSISTANT_DELETE_EMPLOYEE_FOR_EXCHANGE = 'PLANNING_ASSISTANT_DELETE_EMPLOYEE_FOR_EXCHANGE'
export const PLANNING_ASSISTANT_SET_CURRENT_SHIFT = 'PLANNING_ASSISTANT_SET_CURRENT_SHIFT'
export const PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID = 'PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID'
export const PLANNING_ASSISTANT_SET_SHIFT_TEMPLATE_ITEM = 'PLANNING_ASSISTANT_SET_SHIFT_TEMPLATE_ITEM'
export const PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_IS_PROJECT = 'PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_IS_PROJECT'
export const PLANNING_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT = 'PLANNING_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT'
export const PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE = 'PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE'
export const PLANNING_ASSISTANT_SET_FREE_PERIODICITY_PLANNING_ID = 'PLANNING_ASSISTANT_SET_FREE_PERIODICITY_PLANNING_ID'
export const PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST = 'PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST'
export const PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST = 'PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST'
export const PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS = 'PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS'
//</editor-fold>
// EmployeeForm Password
export const SET_EMPLOYEE_PASSWORD = 'SET_EMPLOYEE_PASSWORD'
export const CHANGE_EMPLOYEE_PASSWORD = 'CHANGE_EMPLOYEE_PASSWORD'

// MASTER DATA - TIME MODELS
export const LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST = 'LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST'
export const UPDATE_DELETE_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL = 'UPDATE_DELETE_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL'

// Company settings
export const GET_COMPANY_SETTINGS = 'GET_COMPANY_SETTINGS'
export const CHANGE_COMPANY_SETTINGS = 'CHANGE_COMPANY_SETTINGS'
export const CHANGE_COMPANY_SETTINGS_WITH_WALLPAPER = 'CHANGE_COMPANY_SETTINGS_WITH_WALLPAPER'
export const FETCH_EMPLOYEE_HIERARCHY_LIST = 'FETCH_EMPLOYEE_HIERARCHY_LIST'
export const UPDATE_EMPLOYEE_HIERARCHY_LIST = 'UPDATE_EMPLOYEE_HIERARCHY_LIST'
export const GET_LOAD_INTRO_DATA = 'GET_LOAD_INTRO_DATA'
export const FETCH_LANGUAGE_LIST = 'FETCH_LANGUAGE_LIST'

// EmployeeForm Capacity TIME MODELS
export const LOAD_EMPLOYEE_TIME_MODEL = 'LOAD_EMPLOYEE_TIME_MODEL'

// EmployeeForm Cost Centre model
export const LOAD_EMPLOYEE_COST_CENTER_MODEL = 'LOAD_EMPLOYEE_COST_CENTER_MODEL'

// EmployeeForm Qcq Qualification
export const LOAD_EMPLOYEE_QCQ_QUALIFICATION = 'LOAD_EMPLOYEE_QCQ_QUALIFICATION'
export const EDIT_EMPLOYEE_QCQ_QUALIFICATION = 'EDIT_EMPLOYEE_QCQ_QUALIFICATION'

// EmployeeForm Qcq Competence
export const LOAD_EMPLOYEE_QCQ_COMPETENCE = 'LOAD_EMPLOYEE_QCQ_COMPETENCE'
export const EDIT_EMPLOYEE_QCQ_COMPETENCE = 'EDIT_EMPLOYEE_QCQ_COMPETENCE'

//EmployeeForm Qcq Quality
export const LOAD_EMPLOYEE_QCQ_QUALITY = 'LOAD_EMPLOYEE_QCQ_QUALITY'
export const INSERT_EMPLOYEE_QCQ_QUALITY = 'INSERT_EMPLOYEE_QCQ_QUALITY'

// Messaging
export const MESSAGING_LOAD_NEW_MESSAGES = 'MESSAGING_LOAD_NEW_MESSAGES'
export const MESSAGING_DELETE_MESSAGES = 'MESSAGING_DELETE_MESSAGES'
export const ADD_USER_MESSAGES = 'ADD_USER_MESSAGES'
export const REMOVE_USER_MESSAGES = 'REMOVE_USER_MESSAGES'
export const DELETE_USER_MESSAGES = 'DELETE_USER_MESSAGES'

//Reports
export const LOAD_REPORTS_LIST = 'LOAD_REPORTS_LIST'
export const GENERATE_REPORT = 'GENERATE_REPORT'
export const GENERATE_MULTI_REPORT = 'GENERATE_MULTI_REPORT'
export const LOAD_DATES_BY_YEAR = 'LOAD_DATES_BY_YEAR'

//Employee form
export const FETCH_EMPLOYEE_BY_ID = 'FETCH_EMPLOYEE_BY_ID'
export const CHANGE_EMPLOYEE_DATA = 'CHANGE_EMPLOYEE_DATA'
export const FETCH_EMPLOYEE_PHOTO = 'FETCH_EMPLOYEE_PHOTO'
export const FETCH_EMPLOYEE_ADDITIONAL = 'FETCH_EMPLOYEE_ADDITIONAL'
export const SAVE_EMPLOYEE_ADDITIONAL = 'SAVE_EMPLOYEE_ADDITIONAL'

//Version
export const FETCH_VERSION = 'FETCH_VERSION'
export const FETCH_VERSIONS = 'FETCH_VERSIONS'

// Absence
export const LOAD_ABSENCE_REASON_LIST = 'LOAD_ABSENCE_REASON_LIST'
export const LOAD_ABSENCES = 'LOAD_ABSENCES'
export const CREATE_NEW_ABSENCE = 'CREATE_NEW_ABSENCE'
export const CREATE_NEW_PERIODICITY_ABSENCE = 'CREATE_NEW_PERIODICITY_ABSENCE'
export const EDIT_PERIODICITY_ABSENCE = 'EDIT_PERIODICITY_ABSENCE'
export const FETCH_ABSENCE_SERIE_DATA = 'FETCH_ABSENCE_SERIE_DATA'
export const DELETE_ABSENCE_SERIE = 'DELETE_ABSENCE_SERIE'
export const EDIT_ABSENCE = 'EDIT_ABSENCE'
export const DELETE_ABSENCE = 'DELETE_ABSENCE'
export const DELETE_ABSENCES_CHECKED_LIST = 'DELETE_ABSENCES_CHECKED_LIST'
export const APPROVED_ABSENCES_CHECKED_LIST = 'APPROVED_ABSENCES_CHECKED_LIST'
export const ABSENCE_DRAG_SAVE = 'ABSENCE_DRAG_SAVE'

// Absences assistant
export const ABSENCES_ASSISTANT_RESET_STATE = 'ABSENCES_ASSISTANT_RESET_STATE'
export const ABSENCES_ASSISTANT_INIT_FROM_PAYLOAD = 'ABSENCES_ASSISTANT_INIT_FROM_PAYLOAD'
export const ABSENCES_ASSISTANT_SET_START_END_DATA = 'ABSENCES_ASSISTANT_SET_START_END_DATA'
export const ABSENCES_ASSISTANT_SET_ABSENCE_REASON_ITEM = 'ABSENCES_ASSISTANT_SET_ABSENCE_REASON_ITEM'
export const ABSENCES_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING = 'ABSENCES_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING'
export const ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST = 'ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST'
export const ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST = 'ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST'
export const ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE = 'ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE'
export const ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE = 'ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE'
export const ABSENCES_ASSISTANT_SET_CURRENT_ABSENCE = 'ABSENCES_ASSISTANT_SET_CURRENT_ABSENCE'
export const ABSENCES_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT = 'ABSENCES_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT'
export const ABSENCES_ASSISTANT_SET_PERIODICITY = 'ABSENCES_ASSISTANT_SET_PERIODICITY'
export const ABSENCES_ASSISTANT_SET_IS_EDITING_SERIE = 'ABSENCES_ASSISTANT_SET_IS_EDITING_SERIE'
export const ABSENCES_ASSISTANT_SET_PERIODICITY_SERIE = 'ABSENCES_ASSISTANT_SET_PERIODICITY_SERIE'

//Calendar event
export const LOAD_CALENDAR_EVENT_LIST = 'LOAD_CALENDAR_EVENT_LIST'
export const CREATE_CALENDAR_EVENT = 'CREATE_CALENDAR_EVENT'
export const EDIT_CALENDAR_EVENT = 'EDIT_CALENDAR_EVENT'

// Calendaer event assistant
export const CALENDAR_EVENT_ASSISTANT_RESET_STATE = 'CALENDAR_EVENT_ASSISTANT_RESET_STATE'
export const CALENDAR_EVENT_ASSISTANT_INIT_FROM_PAYLOAD = 'CALENDAR_EVENT_ASSISTANT_INIT_FROM_PAYLOAD'
export const CALENDAR_EVENT_ASSISTANT_SET_START_END_DATA = 'CALENDAR_EVENT_ASSISTANT_SET_START_END_DATA'

export const CALENDAR_EVENT_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING = 'CALENDAR_EVENT_ASSISTANT_SET_EMPLOYEE_LIST_FOR_PLANNING'
export const CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST = 'CALENDAR_EVENT_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST'
export const CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST = ' CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST'
export const CALENDAR_EVENT_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT = 'CALENDAR_EVENT_ASSISTANT_SET_FILTERED_EMPLOYEES_BY_DEPARTMENT'
export const CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY = 'CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY'
export const CALENDAR_EVENT_ASSISTANT_SET_IS_EDITING_SERIE = 'CALENDAR_EVENT_ASSISTANT_SET_IS_EDITING_SERIE'
export const CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_SERIE = 'CALENDAR_EVENT_ASSISTANT_SET_PERIODICITY_SERIE'

// Dashboard
export const FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA'
export const UPDATE_DASHBOARD_SETTINGS = 'UPDATE_DASHBOARD_SETTINGS'
export const RESET_DASHBOARD_SETTINGS = 'RESET_DASHBOARD_SETTINGS'

//Email settings
export const FETCH_EMAIL_TEMPLATE_LIST = 'FETCH_EMAIL_TEMPLATE_LIST'
export const SAVE_EMAIL_TEMPLATE = 'SAVE_EMAIL_TEMPLATE'
export const LOAD_EMAIL_SMTP_SETTINGS = 'LOAD_EMAIL_SMTP_SETTINGS'
export const SAVE_EMAIL_SMTP_SETTINGS = 'SAVE_EMAIL_SMTP_SETTINGS'

//Security settings
export const GET_LOGGED_IN_USERS = 'GET_LOGGED_IN_USERS'
export const LOG_USER_OUT_BY_TOKEN = 'LOG_USER_OUT_BY_TOKEN'
export const FETCH_EMPLOYEE_LEVEL = 'FETCH_EMPLOYEE_LEVEL'
export const UPDATE_EMPLOYEE_LEVEL = 'UPDATE_EMPLOYEE_LEVEL'
export const GET_EMPLOYEE_SECURITY = 'GET_EMPLOYEE_SECURITY'

//Configuration settings
export const FETCH_REQUIREMENTS_EMPLOYEE_AND_SECURITY = 'FETCH_REQUIREMENTS_EMPLOYEE_AND_SECURITY'
export const FETCH_EMPLOYEE_REQUIREMENTS = 'FETCH_EMPLOYEE_REQUIREMENTS'
export const FETCH_SECURITY_REQUIREMENTS = 'FETCH_SECURITY_REQUIREMENTS'
export const FETCH_REQUIREMENTS_METADATA = 'FETCH_REQUIREMENTS_METADATA'
export const SAVE_EMPLOYEE_REQUIREMENTS = 'SAVE_EMPLOYEE_REQUIREMENTS'
export const DELETE_EMPLOYEE_REQUIREMENTS = 'DELETE_EMPLOYEE_REQUIREMENTS'
export const SAVE_SECURITY_ROLE_REQUIREMENTS = 'SAVE_SECURITY_ROLE_REQUIREMENTS'
export const DELETE_SECURITY_ROLE_REQUIREMENTS = 'DELETE_SECURITY_ROLE_REQUIREMENTS'

//Address
export const FETCH_ADDRESS_GROUP = 'FETCH_ADDRESS_GROUP'
export const FETCH_ADDRESS_LIST = 'FETCH_ADDRESS_LIST'
export const SEARCH_ADDRESS = 'SEARCH_ADDRESS'
export const FETCH_SALUTATION = 'FETCH_SALUTATION'
export const FETCH_TITLE_LIST = 'FETCH_TITLE_LIST'
export const FETCH_LAND_LIST = 'FETCH_LAND_LIST'
export const FETCH_FUNCTION_LIST = 'FETCH_FUNCTION_LIST'
export const CREATE_ADDRESS = 'CREATE_ADDRESS'
export const FETCH_ADDRESS_DETAIL = 'FETCH_ADDRESS_DETAIL'
export const CREATE_ADDRESS_EMPLOYEE = 'CREATE_ADDRESS_EMPLOYEE'
export const FETCH_ADDRESS_COLOR_LIST = 'FETCH_ADDRESS_COLOR_LIST'
export const FETCH_ADDRESS_POST_CODE_DATA = 'FETCH_ADDRESS_POST_CODE_DATA'
export const FETCH_ADDRESS_FELD_LIST = 'FETCH_ADDRESS_FELD_LIST'
export const FETCH_ADDRESS_CONTACT_LIST = 'FETCH_ADDRESS_CONTACT_LIST'
export const FETCH_EMPLOYEE_CONTACT_LIST = 'FETCH_EMPLOYEE_CONTACT_LIST'
export const FETCH_AGENCY_LIST = 'FETCH_AGENCY_LIST'

export const FETCH_ADDRESS_ADDITIONAL = 'FETCH_ADDRESS_ADDITIONAL'
export const SAVE_ADDRESS_ADDITIONAL = 'SAVE_ADDRESS_ADDITIONAL'

export const FETCH_ADDRESS_FUNCTION_LIST = 'FETCH_ADDRESS_FUNCTION_LIST'
export const FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST = 'FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST'
export const ADDRESS_RESPONSIBLE_EMPLOYEE = 'ADDRESS_RESPONSIBLE_EMPLOYEE'

export const FETCH_NOTES = 'FETCH_NOTES'
export const FETCH_NOTES_TYPE_LIST = 'FETCH_NOTES_TYPE_LIST'
export const SAVE_NOTE = 'SAVE_NOTE'
export const FETCH_NOTE_ATTACHMENT_LIST = 'FETCH_NOTE_ATTACHMENT_LIST'
export const FETCH_NOTE_ATTACHMENT_BY_ID = 'FETCH_NOTE_ATTACHMENT_BY_ID'
export const SAVE_NOTE_ATTACHMENT = 'SAVE_NOTE_ATTACHMENT'
export const DELETE_NOTE_ATTACHMENT = 'DELETE_NOTE_ATTACHMENT'

export const SET_DISPOSITION_ADDRESS = 'SET_DISPOSITION_ADDRESS'
export const FETCH_PROJECT_GROUP = 'FETCH_PROJECT_GROUP'
export const FETCH_ADDRESSES_PROJECT_ADDRESS = 'FETCH_ADDRESSES_PROJECT_ADDRESS'
export const FETCH_COUNTRIES_LIST = 'FETCH_COUNTRIES_LIST'
export const SAVE_ADDRESSES_PROJECT_ADDRESS = 'SAVE_ADDRESSES_PROJECT_ADDRESS'
export const UPDATE_ADDRESSES_PROJECT_ADDRESS = 'UPDATE_ADDRESSES_PROJECT_ADDRESS'
export const DELETE_ADDRESSES_PROJECT_ADDRESS = 'DELETE_ADDRESSES_PROJECT_ADDRESS'
export const FETCH_SEARCH_ADDRESS_LIST = 'FETCH_SEARCH_ADDRESS_LIST'
export const FETCH_GENERAL_SEARCH_ADDRESS_LIST = 'FETCH_GENERAL_SEARCH_ADDRESS_LIST'
export const FETCH_ADDRESS_EMPLOYEE_LIST = 'FETCH_ADDRESS_EMPLOYEE_LIST'
export const FETCH_ADDRESS_WEB_REPORT = 'FETCH_ADDRESS_WEB_REPORT'
export const SAVE_ADDRESS_WEB_REPORT = 'SAVE_ADDRESS_WEB_REPORT'

export const FETCH_PROJECT_SPECIFICATIONS = 'FETCH_PROJECT_SPECIFICATIONS'
export const CREATE_PROJECT_SPECIFICATIONS = 'CREATE_PROJECT_SPECIFICATIONS'
export const UPDATE_PROJECT_SPECIFICATIONS = 'UPDATE_PROJECT_SPECIFICATIONS'
export const DELETE_PROJECT_SPECIFICATIONS = 'DELETE_PROJECT_SPECIFICATIONS'

//Disposition
export const FETCH_DISPOSITION_JOB_LIST = 'FETCH_DISPOSITION_JOB_LIST'
export const SAVE_DISPOSITION_JOB_DATA = 'SAVE_DISPOSITION_JOB_DATA'
export const GET_DISPOSITION_JOB_DATA = 'GET_DISPOSITION_JOB_DATA'
export const DELETE_DISPOSITION_JOB = 'DELETE_DISPOSITION_JOB'
export const FETCH_DISPOSITION_ADDRESS_LIST = 'FETCH_DISPOSITION_ADDRESS_LIST'
export const FETCH_DISPOSITION_REALLOCATION_ADDRESS_LIST = 'FETCH_DISPOSITION_REALLOCATION_ADDRESS_LIST'
export const FIND_PERSON_FOR_DISPOSITION_JOB = 'FIND_PERSON_FOR_DISPOSITION_JOB'
export const UPDATE_DISPOSITION_JOB_PERSON_LIST = 'UPDATE_DISPOSITION_JOB_PERSON_LIST'
export const ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB = 'ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB'
export const ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB_REALLOCATION = 'ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB_REALLOCATION'
export const END_DISPOSITION_JOB = 'END_DISPOSITION_JOB'
export const SET_DISPOSITION_JOB_STATUS_LIST = 'SET_DISPOSITION_JOB_STATUS_LIST'
export const FETCH_DISPOSITION_WEEK_PERIOD_LIST = 'FETCH_DISPOSITION_WEEK_PERIOD_LIST'

export const FETCH_SUBSTITUTION_LIST = 'FETCH_SUBSTITUTION_LIST'
export const SUBSTITUTION_START_PROCESSING = 'SUBSTITUTION_START_PROCESSING'
export const CHANGE_SUBSTITUTION_STATUS = 'CHANGE_SUBSTITUTION_STATUS'

export const FETCH_REPLACEMENT_DISPOSITION_LIST = 'FETCH_REPLACEMENT_DISPOSITION_LIST'
export const FETCH_REPLACEMENT_LIST = 'FETCH_REPLACEMENT_LIST'
export const UPDATE_REPLACEMENTS = 'UPDATE_REPLACEMENTS'
export const SAVE_REPLACEMENT_DETAILS = 'SAVE_REPLACEMENT_DETAILS'
export const FETCH_REPLACEMENTS_DETAILS = 'FETCH_REPLACEMENTS_DETAILS'
export const UPDATE_REPLACEMENT_PERSON_LIST = 'UPDATE_REPLACEMENT_PERSON_LIST'
export const ASSIGN_EMPLOYEE_TO_REPLACEMENT = 'ASSIGN_EMPLOYEE_TO_REPLACEMENT'
export const FINISH_REPLACEMENT = 'FINISH_REPLACEMENT'
export const SET_IS_DISPOSITION_JOB_STATUS = 'SET_IS_DISPOSITION_JOB_STATUS'

//Information
export const FETCH_INFORMATION_DATA = 'FETCH_INFORMATION_DATA'

//Project
export const FETCH_PROJECT_DATE = 'FETCH_PROJECT_DATE'
export const FETCH_SEARCH_PROJECT_LIST = 'FETCH_SEARCH_PROJECT_LIST'
export const GET_PROJECT_DETAIL = 'GET_PROJECT_DETAIL'
export const GET_PROJECT_DETAIL_HEADER = 'GET_PROJECT_DETAIL_HEADER'
export const GET_PROJECT_DETAIL_FOOTER = 'GET_PROJECT_DETAIL_FOOTER'
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const GET_PROJECT_DETAIL_LOOKUPS = 'GET_PROJECT_DETAIL_LOOKUPS'
export const EDIT_PROJECT_DETAIL = 'EDIT_PROJECT_DETAIL'
export const DELETE_PROJECT_DETAIL = 'DELETE_PROJECT_DETAIL'
export const PROJECT_ASSISTANT_FETCH_START = 'PROJECT_ASSISTANT_FETCH_START'
export const PROJECT_ASSISTANT_CREATE_PROJECT = 'PROJECT_ASSISTANT_CREATE_PROJECT'
export const PROJECT_ASSISTANT_FETCH_DETAIL_START = 'PROJECT_ASSISTANT_FETCH_DETAIL_START'
export const PROJECT_ASSISTANT_FETCH_PRICING = 'PROJECT_ASSISTANT_FETCH_PRICING'
export const PROJECT_ASSISTANT_FETCH_UNIT_LIST = 'PROJECT_ASSISTANT_FETCH_UNIT_LIST'
export const PROJECT_ASSISTANT_CREATE_PROJECT_DETAIL = 'PROJECT_ASSISTANT_CREATE_PROJECT_DETAIL'
export const FETCH_SEARCH_PRODUCT_LIST = 'FETCH_SEARCH_PRODUCT_LIST'
export const QUICK_INSERT_PROJECT_DETAILS = 'QUICK_INSERT_PROJECT_DETAILS'
export const SET_PROJECT_LOCK_STATUS = 'SET_PROJECT_LOCK_STATUS'

export const FETCH_PROJECT_ADDITIONAL_FIELDS = 'FETCH_PROJECT_ADDITIONAL_FIELDS'
export const SAVE_PROJECT_ADDITIONAL = 'SAVE_PROJECT_ADDITIONAL'

//Project-Reprint
export const GET_PROJECT_RECEIPT_LIST = 'GET_PROJECT_RECEIPT_LIST'
export const GET_PROJECT_REPRINT_LIST = 'GET_PROJECT_REPRINT_LIST'
export const PROJECT_REPRINT = 'PROJECT_REPRINT'
export const PROJECT_PREVIEW = 'PROJECT_PREVIEW'
export const PROJECT_REPRINT_CANCEL = 'PROJECT_REPRINT_CANCEL'
export const GET_PROJECT_ARCHIVE_LIST = 'GET_PROJECT_ARCHIVE_LIST'
export const GET_PROJECT_PDF_NAME = 'GET_PROJECT_PDF_NAME'
export const GET_PROJECT_PDF = 'GET_PROJECT_PDF'
export const GET_PROJECT_BELEG_DATA = 'GET_PROJECT_BELEG_DATA'
export const UPDATE_PROJECT_BELEG_DATA = 'UPDATE_PROJECT_BELEG_DATA'
export const GET_PROJECT_LOOK_UPS = 'GET_PROJECT_LOOK_UPS'
export const GET_PROJECT_HEADER_FOOTER_TEXT = 'GET_PROJECT_HEADER_FOOTER_TEXT'
export const UPDATE_PROJECT_HEADER_FOOTER_TEXT = 'UPDATE_PROJECT_HEADER_FOOTER_TEXT'
export const GET_PROJECT_REPRINT_ACCOUNTING_RECORDS = 'GET_PROJECT_REPRINT_ACCOUNTING_RECORDS'
export const GET_PROJECT_REPRINT_PAYMENT_INFORMATION = 'GET_PROJECT_REPRINT_PAYMENT_INFORMATION'

//Project-Booking
export const BOOKING_ASSISTANT_FETCH_START_BOOKING_DATA = 'BOOKING_ASSISTANT_FEETCH_START_BOOKING_DATA'
export const BOOKING_ASSISTANT_GO_TO_POSITIONEN_STEP = 'BOOKING_ASSISTANT_GO_TO_POSITIONEN_STEP'
export const BOOKING_ASSISTANT_GO_TO_MENGEN_STEP = 'BOOKING_ASSISTANT_GO_TO_MENGEN_STEP'
export const BOOKING_ASSISTANT_SAVE_MENGEN_STEP = 'BOOKING_ASSISTANT_SAVE_MENGEN_STEP'
export const BOOKING_ASSISTANT_GO_TO_BELEG_STEP = 'BOOKING_ASSISTANT_GO_TO_BELEG_STEP'
export const BOOKING_ASSISTANT_SAVE_BELEG_STEP = 'BOOKING_ASSISTANT_SAVE_BELEG_STEP'
export const BOOKING_ASSISTANT_HAS_FIBU_STEP = 'BOOKING_ASSISTANT_HAS_FIBU_STEP'
export const BOOKING_ASSISTANT_GO_TO_FIBU_STEP = 'BOOKING_ASSISTANT_GO_TO_FIBU_STEP'
export const BOOKING_ASSISTANT_SAVE_FIBU_STEP = 'BOOKING_ASSISTANT_SAVE_FIBU_STEP'
export const BOOKING_ASSISTANT_GO_TO_PAPIERI_STEP = 'BOOKING_ASSISTANT_GO_TO_PAPIERI_STEP'
export const BOOKING_ASSISTANT_FINISH_BOOKING = 'BOOKING_ASSISTANT_FINISH_BOOKING'
export const BOOKING_ASSISTANT_CANCEL_BOOKING = "BOOKING_ASSISTANT_CANCEL_BOOKING"

//Tools
export const FETCH_TOOLS = 'FETCH_TOOLS'
export const RUN_TOOLS = 'RUN_TOOLS'

//Printing
export const FETCH_PRINTING_ACTIVITY_LIST = 'FETCH_PRINTING_ACTIVITY_LIST'

//Products
export const FETCH_PRODUCT_GROUP = 'FETCH_PRODUCT_GROUP'

export const FETCH_PLANING_FILTER = 'FETCH_PLANING_FILTER'